import { Box, Paper, styled } from "@mui/material";

export const GraphContainer = styled(Paper)`
  padding: ${({ theme }) => theme.spacing(2)};
  border-radius: ${({ theme }) => theme.spacing(1)};
  margin-bottom: ${({ theme }) => theme.spacing(2)};
  position: relative;
  overflow: hidden;
`;

export const GraphTitle = styled(Box)`
  margin-bottom: ${({ theme }) => theme.spacing(2)};
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ChartWrapper = styled(Box)`
  display: flex;
  justify-content: center;
  position: relative;
`;

export const ChartContainer = styled(Box)`
  width: 100%;
  max-width: 100%;
  height: 200px;
  padding-left: 30px;
`;

export const ChartImages = styled(Box)`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(3)};
  margin-top: ${({ theme }) => theme.spacing(0.5)};
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  z-index: 1;
  padding: ${({ theme }) => theme.spacing(2, 0)};

  & img {
    max-width: 100%;
    width: 40px;
    height: 40px;
    object-fit: contain;
  }

  ${({ theme }) => theme.breakpoints.down('sm')} {
    & img {
      width: 30px;
      height: 30px;
    }
  }
`;

interface TooltipProps {
  color: string;
}

export const TooltipContainer = styled(Box) <TooltipProps>`
  padding: ${({ theme }) => theme.spacing(1)};
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(0.5)};
  background-color: ${({ theme }) => theme.palette.background.paper};
  box-shadow: ${({ theme }) => theme.shadows[3]};
  border-radius: ${({ theme }) => theme.shape.borderRadius}px;

  & .indicator {
    height: 12px;
    width: 12px;
    border-radius: 50%;
    background-color: ${({ color }) => color};
  }
`;

export const StatsNotFound = styled(Box)`
  text-align: center;
  margin: ${({ theme }) => theme.spacing(3, 0)};
  padding: ${({ theme }) => theme.spacing(2)};
  color: ${({ theme }) => theme.palette.text.secondary};
  font-weight: bold;
`;

export const LiveIndicator = styled(Box)`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(0.5)};

  & .dot {
    width: 8px;
    height: 8px;
    border-radius: 50%;
    background-color: ${({ theme }) => theme.palette.success.main};
    animation: pulse 1.5s infinite;
  }

  @keyframes pulse {
    0% {
      opacity: 1;
    }
    50% {
      opacity: 0.4;
    }
    100% {
      opacity: 1;
    }
  }
`;

export const PossessionStats = styled(Box)`
  display: flex;
  justify-content: space-between;
  margin-top: ${({ theme }) => theme.spacing(1)};
  padding: ${({ theme }) => theme.spacing(1, 0)};
`;

export const TeamPossession = styled(Box)`
  display: flex;
  flex-direction: column;
  align-items: center;

  & .percentage {
    font-weight: bold;
    font-size: 1.2rem;
  }
`;